import createIcon from '../../createIcon';

/**
 * @component @name RemoveModerator
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNjM1MiAyMS43M0wxOS4wOTUyIDE4LjE4TDIuNjM1MjMgMS43MkwxLjM2NTIzIDIuOTlMMy4zNzUyMyA1SDMuMzY1MjNWMTFDMy4zNjUyMyAxNi41NSA3LjIwNTIzIDIxLjc0IDEyLjM2NTIgMjNDMTQuNTI1MiAyMi40NyAxNi40NDUyIDIxLjI0IDE3Ljk2NTIgMTkuNTlMMjEuMzY1MiAyM0wyMi42MzUyIDIxLjczWk0yMC4wMzUyIDE2LjU5QzIwLjg3NTIgMTQuODcgMjEuMzY1MiAxMi45NiAyMS4zNjUyIDExVjVMMTIuMzY1MiAxTDYuODg1MjMgMy40NEwyMC4wMzUyIDE2LjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RemoveModerator = createIcon('RemoveModerator', [
  [
    'path',
    {
      d: 'M22.6352 21.73L19.0952 18.18L2.63523 1.72L1.36523 2.99L3.37523 5H3.36523V11C3.36523 16.55 7.20523 21.74 12.3652 23C14.5252 22.47 16.4452 21.24 17.9652 19.59L21.3652 23L22.6352 21.73ZM20.0352 16.59C20.8752 14.87 21.3652 12.96 21.3652 11V5L12.3652 1L6.88523 3.44L20.0352 16.59Z',
      key: '1safrm',
    },
  ],
]);

export default RemoveModerator;
